import { useQuery } from "@tanstack/react-query";

import api, { RestApiOptions } from "@/api";

import { ILanguage } from "@/view/TiptapArticleBody/components/TranslateDrawer/TranslateDrawer.interface";

export const TRANSLATIONS_QUERY_KEY = ["translatorLanguages"];

const options: RestApiOptions = {
  basePath: "/",
  timeout: 5000,
};

const resource = `api/v3/translator-languages/`;

export const TRANSLATIONS_QUERY_FN = async (): Promise<ILanguage[]> =>
  await api(options).get(resource);

export const useGetTranslatorLanguages = (): ILanguage[] => {
  const query = useQuery<ILanguage[]>({
    queryKey: TRANSLATIONS_QUERY_KEY,
    queryFn: TRANSLATIONS_QUERY_FN,
    refetchOnWindowFocus: false,
  });

  const hasQueryError = !query?.isLoading && query?.isError;

  if (hasQueryError) return [];

  return query.data || [];
};
